module.exports = __webpack_public_path__ + "static/media/hand-right-back.4cccffc3.png";